export const GET_PREDICTIVE_ROUTING = 'getPredictiveRouting';
export const GET_PREDICTIVE_ROUTING_CONFIG = 'getPredictiveRoutingConfig';
export const CREATE_PREDICTIVE_ROUTING_CONFIG = 'createPredictiveRoutingConfig';
export const UPDATE_PREDICTIVE_ROUTING_CONFIG = 'updatePredictiveRoutingConfig';
export const DELETE_PREDICTIVE_ROUTING_CONFIG = 'deletePredictiveRoutingConfig';
export const GET_PREDICTIVE_ROUTING_CONFIG_REFERENCES = 'getPredictiveRoutingConfigReferences';
export const CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_ADVANCED = 'convertPredictiveRoutingConfigToAdvanced';
export const CONVERT_PREDICTIVE_ROUTING_CONFIG_TO_BASIC = 'convertPredictiveRoutingConfigToBasic';
